import React from "react";
import { useCountryData, useStateData } from "lib/config";

import { Link } from "react-router-dom";

import DashboardBreadcrumbs from "components/DashboardBreadcrumbs";

export default function StateLevelBreadcrumbs({ country, state }) {
  const countryData = useCountryData(country);
  const stateData = useStateData(country, state);

  return (
    <DashboardBreadcrumbs>
      <Link to={`/distancing`} style={{ color: "inherit" }}>
        Latam
      </Link>
      <Link to={`/distancing/${country}`} style={{ color: "inherit" }}>
        {countryData?.name}
      </Link>
      {stateData?.name}
    </DashboardBreadcrumbs>
  );
}
